import { useService } from '@policoders/di';
import {
  AlertModalService,
  BreadcrumbService,
  DisplayTable,
  ModalService,
  TTableActions,
  TTableLineActions,
} from '@policoders/ds';
import { useEffect, useState } from 'react';

import HideConditional from '../../../../../shared/components/hide-conditional';
import Loading from '../../../../../shared/components/loading';
import PageHeader from '../../../../../shared/components/page-header';
import PurchaseOrderForm from './purchase-order.form';
import { PurchaseOrder } from './purchase-order.model';
import PurchaseOrderRepository from './purchase-order.repository';
import { PurchaseOrderStore } from './purchase-order.store';

export const PurchaseOrderPage = () => {
  const repository = useService<PurchaseOrderRepository>('PurchaseOrderRepository');
  const store = useService<PurchaseOrderStore>('PurchaseOrderStore');
  const modalService = useService<ModalService>('ModalService');
  const alertService = useService<AlertModalService>('AlertModalService');
  const [lines, setLines] = useState<PurchaseOrder[]>([]);
  const [loading, setLoading] = useState(true);

  const breadcrumb = useService<BreadcrumbService>('BreadcrumbService');
  useEffect(() => {
    breadcrumb.set([
      { label: "Chef's Assistant", value: '/chefs-assistant' },
      { label: 'Compras', value: '/chefs-assistant/stock/purchase-orders' },
    ]);
  }, [breadcrumb]);

  useEffect(() => {
    repository.getAll();
    var subscriber = repository.data$.subscribe(data => {
      setLines(data);
      setLoading(false);
    });
    return () => {
      subscriber.unsubscribe();
    };
  });

  const handleNew = () => {
    const model = new PurchaseOrder();
    store.updateCurrent(model);
    modalService
      .config({
        title: 'novo pedido de compra',
        size: 'xlarge',
        buttonOkLabel: 'Criar',
        buttonOkAction: handleSave,
        children: () => (
          <PurchaseOrderForm
            data={model}
            onChange={state => {
              store.updateCurrent(state);
            }}
          />
        ),
      })
      .open();
  };

  const showMessage = (type: 'error' | 'info', message: string) => {
    alertService
      .config({
        type: type,
        title: 'Erro',
        buttonOkLabel: 'Ok',
        buttonCancelHidden: true,
        children: () => <span>{message}</span>,
      })
      .open();
  };

  const handleSave = async () => {
    console.log('handleSave');

    try {
      const model = store.current;
      console.log('handleSave', model);

      throw new Error('Erro de teste');

      // await repository.add(model);
    } catch (e: any) {
      console.log(e);

      showMessage('error', e.message);
    }
  };

  const handleEdit = (line: PurchaseOrder) => {
    const model = lines.find(x => x.id === line.id);
    if (!model) return;
    modalService
      .config({
        title: `editar pedido de compra (${line.id.split('-')[0]})`,
        size: 'xlarge',
        buttonOkLabel: 'Salvar',
        buttonOkAction: handleSave,
        children: () => (
          <PurchaseOrderForm
            data={model}
            onChange={state => {
              store.updateCurrent(state);
            }}
          />
        ),
      })
      .open();
  };

  const tActions: TTableLineActions[] = [];

  const tColumns = [
    { field: 'id', title: 'Número' },
    { field: 'supplierName', title: 'Fornecedor' },
  ];

  const tHeaderButtons: TTableActions = {
    buttonNew: {
      label: 'Novo',
      action: handleNew,
    },
  };

  return (
    <>
      <PageHeader title="Compras" />
      <Loading active={loading} />

      <HideConditional condition={loading}>
        <DisplayTable
          actions={tActions}
          columns={tColumns}
          headerButtons={tHeaderButtons}
          lines={lines}
          onLineClick={handleEdit}
        />
      </HideConditional>
    </>
  );
};
